import IGetSiteDiaryResponseModel from "interfaces/Response/IGetSiteDiaryResponseModel";
import SiteDiaryItemOrdersProps from "interfaces/SiteDiary/ItemOrder/SiteDiaryItemOrdersProps";

function mapSiteDiaryItemOrdersToSiteDiaryItemOrderViewModels(
  siteDiaryResponseModel: IGetSiteDiaryResponseModel,
  diarySaved: boolean,
  diaryDate: string,
  hwrcSiteId: string
): SiteDiaryItemOrdersProps {
  const siteDiaryItemOrdersProps: SiteDiaryItemOrdersProps = {
    itemOrders: [],
    diarySaved,
    diaryDate,
    hwrcSiteId
  };

  if (
    siteDiaryResponseModel.siteDiary
    && siteDiaryResponseModel.siteDiary.itemOrders
  ) {
    siteDiaryItemOrdersProps.itemOrders = siteDiaryResponseModel.siteDiary.itemOrders.map(entry => (
      {
        hwrcSiteId,
        diaryDate,
        id: entry.id,
        item: entry.item,
        quantity: entry.quantity,
        orderType: entry.orderType,
        size: entry.size,
        recipient: entry.recipient,
        status: entry.status,
        updatedDate: new Date(entry.updatedDate)
      }
    ));
  }

  return siteDiaryItemOrdersProps;
}

export { mapSiteDiaryItemOrdersToSiteDiaryItemOrderViewModels };
